import { Space } from "antd";
import { CostComparisonHeader } from "src/modules/CostComparisonManager/components/CostComparisonHeader/CostComparisonHeader";
import { LensesComparisonTable } from "src/modules/CostComparisonManager/tabs/LensesTab/components/LensesComparisonTable/LensesComparisonTable";

export const LensesTab: React.FC = () => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={25}>
      <CostComparisonHeader />
      <LensesComparisonTable />
    </Space>
  );
};
